<template>
    <div class="account-section-container" >
        <h1 class="account-section-header" v-if="title">{{title}}</h1>
      <slot></slot>
    </div>
</template>
<script>
    
    export default {
        props: {
            title: { required: false }
        },
    }
</script>